import React, { useMemo } from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import classNames from 'classnames';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';

import { usePortfolioStreamedOrSelectedSymbolFromOrders } from 'portfolio/store/hooks';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useVenueExecCapsuleConfigSlice } from 'widgets/venueAnalysis/capsules/venueExecCapsule/store/config/configslice';
import { venueExecCapsuleStreamedDataSelectors } from 'widgets/venueAnalysis/capsules/venueExecCapsule/store/stream/streamSlice';
import { getVenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import VenueExecCapsuleSettings, {
    VenueExecCapsuleSettingsText,
} from './settings/VenueExecCapsuleSettings';
import { VenueExecCapsuleContent } from './content/VenueExecCapsuleContent';
import VenueExecCapsuleChartHelp from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/VenueExecCapsuleChartHelp';
import { useCapsuleBoundSymbol } from 'widgets/tiles/components/tile/hooks';

export function VenueExecCapsule() {
    const { config, dispatchConfigChanged } = useVenueExecCapsuleConfigSlice();

    const { useWidgetStreamData, useWidgetMessages } =
        venueExecCapsuleStreamedDataSelectors;
    const streamData = useWidgetStreamData();
    const messages = useWidgetMessages();

    const { symbol, linked } = useCapsuleBoundSymbol();

    const data = getVenueAnalysisData(
        streamData,
        undefined,
        config.includePreviousDaysFills
    );

    const portfolioHasStreamedOrSelectedSymbol =
        !!usePortfolioStreamedOrSelectedSymbolFromOrders();

    const showOrderData = linked && portfolioHasStreamedOrSelectedSymbol;

    const { widgetKey } = useWidgetContext();

    useWidgetStream();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warning = useMemo(() => <SymbolWarning />, [config]);

    const cssClasses = classNames('VenueExecCapsule');

    return (
        <WidgetTile className={cssClasses}>
            <TileToolbar
                title="Fills By Venue"
                settingsBody={<VenueExecCapsuleSettings />}
                settingsHeader={VenueExecCapsuleSettingsText}
                settingsClassName="VenueExecCapsuleSettingsModal"
                preceedingItems={<VenueExecCapsuleChartHelp />}
                messages={symbol ? messages : []}
                wideTitle={true}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus warning={warning}>
                    <VenueExecCapsuleContent
                        data={data}
                        config={config}
                        dispatchConfigChanged={dispatchConfigChanged}
                        symbol={symbol}
                        capsuleKey={widgetKey}
                        showOrderData={showOrderData}
                    />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );

    function SymbolWarning() {
        return (
            <span>
                Select a symbol or specify one in the&nbsp;
                <ConfigSettingsModal
                    dispatcher={dispatchConfigChanged}
                    headerText={VenueExecCapsuleSettingsText}
                    triggerText={'Capsule Settings'}
                    renderSettings={(p) => <VenueExecCapsuleSettings {...p} />}
                />
                .
            </span>
        );
    }
}
